// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"eb1c78bc","224":"85b2464d","453":"f63eee4e","923":"3c1c24d9"}[chunkId] + ".chunk.js";
};